import React from 'react'
import { ContainerWrapper, TopBarWrapper } from '../StyledComponents'
import {
	Search,
	LanguageSwitcher,
	FontSizeController,
	ThemeSwitcher,
	TopIcons,
} from './Components'

function TopBar() {
	return (
		<TopBarWrapper>
			<ContainerWrapper>
				<Search />
				<LanguageSwitcher />
				<FontSizeController />
				<ThemeSwitcher />
				<TopIcons />
			</ContainerWrapper>
		</TopBarWrapper>
	)
}

export default TopBar
